import * as yup from 'yup'

export const yourInformationFeedbackSchema = (t) => ({
  fullname: yup.string().required(t('reference.fullnameRequired')),
  jobTitle: yup.string().required(t('reference.jobTitleRequired')),
  companyName: yup.string().required(t('reference.companyNameRequired')),
  email: yup
    .string()
    .email(t('reference.emailInvalid'))
    .required(t('reference.emailRequired')),
  phone: yup
    .string()
    .nullable()
    .matches(/^$|^\d{10,12}$/, t('reference.phoneInvalid')),
  candidateRelationship: yup
    .string()
    .required(t('reference.relationshipRequired')),
})

export const confirmationFeedbackSchema = (t) => ({
  confirmInformation: yup
    .boolean()
    .oneOf([true], t('reference.confirmInformationRequired')),
})

const dynamicCategoryShape = (formConfig, t) => {
  const shape = {}
  const ratingMinMax = yup
    .number()
    .min(1)
    .max(5)
    .typeError(t('general.required'))

  const categories = [
    'relationship',
    'performance',
    'recommendation',
    'comments',
  ]
  const configs = formConfig.filter((q) => categories.includes(q.category))

  configs.forEach((q) => {
    if (q.fieldType === 'rating') {
      ;(q.fieldOptions?.options || []).forEach((opt) => {
        shape[opt.value] = opt.is_required
          ? ratingMinMax.required(t('general.required'))
          : ratingMinMax.nullable()
      })
    } else if (q.fieldType === 'inline-multiselect') {
      let validator = yup.array().of(yup.string())
      if (q.isRequired) validator = validator.min(1, t('validation.atLeastOne'))
      if (q.fieldOptions?.maxLimit) {
        validator = validator.max(
          q.fieldOptions.maxLimit,
          t('validation.maxExceeded', { limit: q.fieldOptions.maxLimit }),
        )
      }
      shape[q.key] = validator
    } else {
      let validator =
        q.fieldType === 'number'
          ? yup.number().typeError(t('general.required'))
          : yup.string()
      if (q.isRequired) validator = validator.required(t('general.required'))
      shape[q.key] = validator

      shape[`${q.key}_explanation`] = yup.string().when(q.key, {
        is: (val) =>
          (q.fieldOptions?.options || []).find((o) => o.value === val)?.explain,
        then: (s) => s.required(t('general.required')),
        otherwise: (s) => s.nullable(),
      })
    }
  })

  return shape
}

export const buildFeedbackSchema = (formConfig, t) =>
  yup.object().shape({
    ...yourInformationFeedbackSchema(t),
    ...dynamicCategoryShape(formConfig, t),
    ...confirmationFeedbackSchema(t),
  })
